<template>
  <div id="show-group" class="no-container">
    <div id="content-start-anchor"></div>
    <v-tabs-items
      v-if="isLoaded && group != null"
      v-model="global.selectedAppTab"
      class="pa-3 adapted-window"
      :style="{
        backgroundColor: 'transparent',
        height: screenHeight > 0 ? `${screenHeight}px` : 'auto',
        overflowY: 'auto',
      }"
    >
      <v-tab-item>
        <group-portails-tab :group="group"></group-portails-tab>
      </v-tab-item>
      <v-tab-item>
        <group-presentation-tab
          :group="group"
          :group-portals="listGroupPortals"
        ></group-presentation-tab>
      </v-tab-item>
      <v-tab-item class="pt-3 pb-1 full-height">
        <group-configuration-tab
          :group="group"
          :group-portals="listGroupPortals"
        ></group-configuration-tab>
      </v-tab-item>
      <v-tab-item>
        <group-catalogue-tab :group="group"></group-catalogue-tab>
      </v-tab-item>
      <v-tab-item>
        <group-traduction-tab :group="group"></group-traduction-tab>
      </v-tab-item>
    </v-tabs-items>
    <div v-else>
      <LoadingDialog />
    </div>
  </div>
</template>
<script>
import {
  onMounted,
  ref,
  toRefs,
  watch,
  onUnmounted,
} from "@vue/composition-api";
import Vue from "vue";
import router from "../router";
import global from "@/composables/global";
import { useGroup } from "../composables/group";
import { useTitle } from "@/composables/title";
import LoadingDialog from "@/components/General/LoadingDialog.vue";
import GroupPortailsTab from "./group/GroupPortailsTab.vue";
import GroupPresentationTab from "./group/GroupPresentationTab.vue";
import GroupConfigurationTab from "./group/GroupConfigurationTab.vue";
import GroupCatalogueTab from "./group/GroupCatalogueTab.vue";
import GroupTraductionTab from "./group/GroupTraductionTab.vue";
import { useIframePreview } from "@/composables/iframe-preview";

export default {
  components: {
    LoadingDialog,
    GroupPortailsTab,
    GroupPresentationTab,
    GroupConfigurationTab,
    GroupCatalogueTab,
    GroupTraductionTab,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const {
      showGroup,
      updatePortalConfiguration,
      data,
      currentGroup: group,
    } = useGroup();

    /* Variables */
    const isLoaded = ref(false);
    const groupId = router.currentRoute.params.id;
    const editMode = ref(false);
    const editModeTheme = ref(false);
    const listGroupPortals = ref([]);
    const screenHeight = ref(0);

    /* Méthodes */
    const getListGroupPortals = function (portals) {
      listGroupPortals.value = portals;
    };
    const computeAvailableScreenSpace = function (domId) {
      const anchor = document.getElementById(domId);
      if (anchor) {
        const anchorPosition = anchor.getBoundingClientRect().bottom;
        const totalScreenHeight = window.innerHeight;
        screenHeight.value = totalScreenHeight - anchorPosition;
      }
    };

    const { reloadPreview } = useIframePreview();

    /* Watchers */
    watch(
      () => global.selectedAppTab,
      () => {
        Vue.nextTick(function () {
          // DOM updated
          computeAvailableScreenSpace("content-start-anchor");
        });

        if (global.selectedAppTab == 1 || global.selectedAppTab == 2) {
          reloadPreview();
        }
      },
      { deep: true }
    );

    /* Cycle de vie */
    onMounted(async () => {
      global.tabsDisabled = true;
      global.appTabs = [
        "Portails",
        "Présentation",
        "Configuration",
        "Catalogue",
        "Traduction",
      ];
      setIcon("groupes");
      await showGroup(groupId);
      setTitle(group.value.description);
      global.tabsDisabled = false;
      isLoaded.value = true;
      computeAvailableScreenSpace("content-start-anchor");
    });
    onUnmounted(() => {
      global.appTabs = [];
      global.selectedAppTab = 0;
    });

    return {
      group,
      updatePortalConfiguration,
      groupId,
      ...toRefs(data),
      isLoaded,
      global,
      editMode,
      editModeTheme,
      listGroupPortals,
      screenHeight,
      getListGroupPortals,
    };
  },
};
</script>
